var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.433,
    height: 10.061,
    viewBox: "0 0 18.433 10.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49267",
    "data-name": "Path 49267",
    d: "M-874.788-40.976c.09-.1.153-.188.227-.262q3.718-3.721,7.443-7.435a1.333,1.333,0,0,1,.573-.33.779.779,0,0,1,.838.4.834.834,0,0,1-.071.933,2.5,2.5,0,0,1-.2.209l-8.1,8.105a.878.878,0,0,1-1.458,0q-4.071-4.071-8.137-8.147a1.354,1.354,0,0,1-.333-.571.781.781,0,0,1,.4-.841.834.834,0,0,1,.934.065,2.667,2.667,0,0,1,.228.216l7.421,7.42C-874.962-41.14-874.893-41.076-874.788-40.976Z",
    transform: "translate(884.031 49.022)",
    fill: "#1a1818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.84ec033ae44477fcbf7277038c5bc2f0.svg";
export { ForwardRef as ReactComponent };